'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reduxModulesAuth = require('redux/modules/auth');

var _containersAppApp = require('./containers/App/App');

var _containersAppApp2 = _interopRequireDefault(_containersAppApp);

var _containersAppAppWithMenu = require('./containers/App/AppWithMenu');

var _containersAppAppWithMenu2 = _interopRequireDefault(_containersAppAppWithMenu);

var _containersLoginLogin = require('./containers/Login/Login');

var _containersLoginLogin2 = _interopRequireDefault(_containersLoginLogin);

var _containersNotFound = require('./containers/NotFound');

var _containersNotFound2 = _interopRequireDefault(_containersNotFound);

var _containersEmailTemplatePage = require('./containers/EmailTemplate/Page');

var _containersEmailTemplatePage2 = _interopRequireDefault(_containersEmailTemplatePage);

var _containersUserPage = require('./containers/User/Page');

var _containersUserPage2 = _interopRequireDefault(_containersUserPage);

var _containersDataPage = require('./containers/Data/Page');

var _containersDataPage2 = _interopRequireDefault(_containersDataPage);

var _containersTriggerPage = require('./containers/Trigger/Page');

var _containersTriggerPage2 = _interopRequireDefault(_containersTriggerPage);

var _containersUserProfile = require('./containers/User/Profile');

var _containersUserProfile2 = _interopRequireDefault(_containersUserProfile);

var _containersChartPage = require('./containers/Chart/Page');

var _containersChartPage2 = _interopRequireDefault(_containersChartPage);

exports['default'] = function (store) {

	var requireLogin = function requireLogin(nextState, replaceState, cb) {
		function checkAuth() {
			var _store$getState = store.getState();

			var isLoggedIn = _store$getState.auth.isLoggedIn;

			if (!isLoggedIn) {
				replaceState(null, '/login?backlink=' + encodeURIComponent(nextState.location.pathname + nextState.location.search));
			}
			cb();
		}
		checkAuth();
	};

	return _react2['default'].createElement(
		_reactRouter.Route,
		{ path: '/', component: _containersAppApp2['default'] },
		_react2['default'].createElement(
			_reactRouter.Route,
			{ onEnter: requireLogin, component: _containersAppAppWithMenu2['default'] },
			_react2['default'].createElement(_reactRouter.IndexRoute, { name: 'chart', component: _containersChartPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/chart(/:id)', name: 'chart', component: _containersChartPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/database(/:id)', name: 'data', component: _containersDataPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/trigger(/:id)', name: 'trigger', component: _containersTriggerPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/user(/:id)', name: 'user', component: _containersUserPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/emailtemplate(/:id)', name: 'emailtemplate', menu: 'setting', component: _containersEmailTemplatePage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/profile', name: 'profile', component: _containersUserProfile2['default'] })
		),
		_react2['default'].createElement(_reactRouter.Route, { path: '/login', name: 'login', component: _containersLoginLogin2['default'] }),
		_react2['default'].createElement(_reactRouter.Route, { path: '*', component: _containersNotFound2['default'], status: 404 })
	);
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes.js
 ** module id = 1037
 ** module chunks = 2
 **/